// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__30lXh","itemTitle":"ClientEmergencyInfo_itemTitle__3dqIf","itemText":"ClientEmergencyInfo_itemText__C6BPU"};